import { Component, OnInit } from '@angular/core';
import { AppNavigationHeaderComponent } from '../../../components/navigation-header/app-navigation-header.component';
import { PropertyListTableComponent } from '../property-list-table/property-list-table.component';
import { BreadcrumbLabelDirective } from '../../../directives/breadcrumb-label.directive';

@Component({
	selector: 'app-property-main-tab',
	templateUrl: './property-main-tab.component.html',
	styleUrls: ['./property-main-tab.component.scss'],
	imports: [
		AppNavigationHeaderComponent,
		PropertyListTableComponent,
		BreadcrumbLabelDirective,
	],
})
export class PropertyMainTabComponent {
	propertyListBreadcrumbLabel = $localize`:@@propertyMainTab-propertyListBreadcrumbLabel:Properties`;
	constructor() {}
}
